import { i18nextInit } from '@framework/i18n/intl/init.ts';

i18nextInit({
  lookupLocalStoragePrefix: 'fwpfo',
});
